import { render, staticRenderFns } from "./PipiPupuFile.vue?vue&type=template&id=4eb6f71e"
import script from "./PipiPupuFile.vue?vue&type=script&lang=js"
export * from "./PipiPupuFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports